document.addEventListener('DOMContentLoaded', () => {
  const list = document.querySelector('.js-infinite-scroll-list');
  const trigger = document.querySelector('.js-infinite-scroll-trigger');

  if (!list || !trigger) return;

  let nextUrl = trigger.dataset.nextUrl;
  let isLoading = false;

  const observer = new IntersectionObserver(
    async (entries) => {
      const entry = entries[0];

      if (!entry.isIntersecting || isLoading || !nextUrl) return;

      isLoading = true;

      try {
        const response = await fetch(nextUrl);
        const text = await response.text();
        const html = new DOMParser().parseFromString(text, 'text/html');

        const newItems = html.querySelectorAll(
          '.js-infinite-scroll-list .blog-articles__article'
        );

        newItems.forEach((item) => {
          list.appendChild(item);
        });

        const newTrigger = html.querySelector('.js-infinite-scroll-trigger');
        nextUrl = newTrigger ? newTrigger.dataset.nextUrl : null;

        if (!nextUrl) {
          observer.unobserve(trigger);
          observer.disconnect();
          trigger.remove();
        }
      } catch (error) {
        console.error('Infinite scroll error:', error);
      } finally {
        isLoading = false;
      }
    },
    {
      root: null,
      rootMargin: '0px 0px 200px 0px',
      threshold: 0,
    }
  );

  observer.observe(trigger);
});